import { useEventVideoContext } from 'context/EventVideoContext'
import { useEndSpeakerMutation } from 'graphql/generated'
import { useCurrentUser, useQueryErrorHandler } from 'hooks'

function useEndSpeaker(
  userId: Maybe<string>,
  onCompleted?: Callback
): [Callback, boolean] {
  const { event } = useEventVideoContext()
  const { id: currentUserId } = useCurrentUser()
  const onError = useQueryErrorHandler(
    'Failed to end speaker session. Please try again.'
  )

  const [endSpeaker, { loading: endingSpeaker }] = useEndSpeakerMutation({
    variables: {
      eventId: event.id,
      userId: userId || currentUserId
    },
    onError,
    onCompleted
  })

  return [endSpeaker, endingSpeaker]
}

export default useEndSpeaker
